import * as React from "react";
function SvgAvatar(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-5.284c1.72 0 3.486.693 5.297 2.158-1.8 1.205-3.565 1.808-5.297 1.808-1.732 0-3.505-.603-5.322-1.889 1.828-1.384 3.602-2.077 5.322-2.077zM12 5.4a4.725 4.725 0 110 9.45 4.725 4.725 0 010-9.45z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgAvatar);
export default ForwardRef;
